const Filters = () => (
    <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(4 4)" strokeWidth="2" fill="none" fillRule="evenodd">
            <path
                d="M18.708 4.712a.626.626 0 00-.623-.667H.625A.625.625 0 000 4.712a9.378 9.378 0 007.477 8.516v8.23a.625.625 0 001.025.48l2.5-2.084a.623.623 0 00.225-.48v-6.146a9.377 9.377 0 007.48-8.516z"
                stroke="#223260"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle stroke="#FFF" fill="#F2D86B" cx="19.375" cy="4" r="5" />
        </g>
    </svg>
);
export default Filters;
